/**
 * `JSON.stringify` for embedding JSON-LD inside an inline `<script>` tag.
 *
 * `JSON.stringify` does not escape `<`, `>` or `&`, so any value containing the
 * literal bytes `</script>` terminates the `<script type="application/ld+json">`
 * element regardless of JSON/JS string context — enabling reflected XSS when the
 * data includes user-controlled input (security audit 2026-07-19 C2). Escaping
 * these three characters to their `\uXXXX` forms keeps the JSON valid and the
 * payload inert. (U+2028 / U+2029 need no handling here: an `application/ld+json`
 * block is parsed as data, never executed as JS.)
 *
 * Use this everywhere a JSON-LD object is passed to
 * `dangerouslySetInnerHTML={{ __html: ... }}`.
 */
export function safeJsonLdStringify(data: unknown): string {
  return JSON.stringify(data)
    .replace(/</g, '\\u003c')
    .replace(/>/g, '\\u003e')
    .replace(/&/g, '\\u0026')
}
